export default __webpack_public_path__ + "static/445-3e375bd586e222e80482fb3124212641.gif";